import {observer} from "mobx-react";
import {FieldInput, FieldSelect, FormSection} from "../../ui";
import {ShippingCarrierTypeDto} from "../../../api/fms";
import {FmsShippingFormData, FmsShippingFormValidation} from "../../../store";

const carrierOptions = Object.keys(ShippingCarrierTypeDto)
    .filter(e => e !== ShippingCarrierTypeDto.POST)
    .map(e => ({
        value: e,
        label: e
    }))

interface FmsShippingClientFormProps {
    disabled: boolean
    value: FmsShippingFormData
    validation: FmsShippingFormValidation
    onBlur: () => any
    onChange: (value: FmsShippingFormData) => any
}

const FmsShippingClientForm = observer(function FmsShippingClientForm({
                                                                          disabled,
                                                                          value,
                                                                          validation,
                                                                          onBlur,
                                                                          onChange
                                                                      }: FmsShippingClientFormProps) {
    const {
        carrier,
        clientNumber,
        label
    } = value
    return <>
        <div style={{overflow: 'visible', padding: '1em'}}>
            <FormSection
                label={"Allgemein"}
                children={
                    <>
                        <div className={"columns"}>
                            <div className={"column is-one-third"}>
                                <FieldSelect
                                    disabled={disabled}
                                    label={'Dienstleister'}
                                    options={carrierOptions}
                                    value={carrier}
                                    required={true}
                                    help={validation.carrier}
                                    invalid={Boolean(validation.carrier)}
                                    onBlur={() => onBlur()}
                                    onChange={e => {
                                        onChange({
                                            ...value,
                                            carrier: e as ShippingCarrierTypeDto
                                        })
                                    }}
                                />
                            </div>
                            <div className={"column is-one-third"}>
                                <FieldInput
                                    disabled={disabled}
                                    label={"Manadantennummer"}
                                    required={true}
                                    help={validation.clientNumber}
                                    invalid={Boolean(validation.clientNumber)}
                                    value={clientNumber}
                                    onBlur={() => onBlur()}
                                    onChange={e => {
                                        onChange({
                                            ...value,
                                            clientNumber: e,
                                        })
                                    }}
                                />
                            </div>
                            <div className={"column is-one-third"}>
                                <FieldInput
                                    disabled={disabled}
                                    label={"Anzeige"}
                                    required={true}
                                    help={validation.label}
                                    invalid={Boolean(validation.label)}
                                    value={label}
                                    onBlur={() => onBlur()}
                                    onChange={e => {
                                        onChange({
                                            ...value,
                                            label: e,
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </>
                }
            />
        </div>
    </>
})
export {
    FmsShippingClientForm
}
